import { useState } from 'react';
import styles from './ReadMoreSection.module.css';

interface ReadMoreSectionProps {
  /** The plain-text lines that are always shown. The last line will include an ellipsis and a read more button */
  introLines: string[];
  /** The HTML that is shown when read more is pressed */
  content: string;
}

/** A very basic simple read more section, that takes a number of plain-text initial lines to be shown and then shows a
 * read more button, and then shows some HTML.
 *
 * Note that a proper implementation of this would need to parse the HTML and count the number of letters, excluding any
 * HTML tags
 */
export const ReadMoreSection = ({
  introLines,
  content,
}: ReadMoreSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <div className={styles.readMoreContent}>
        {introLines.map((x, index) => (
          <p key={index}>
            {x}
            {index === introLines.length - 1 && !isExpanded ? (
              // The last line, add the ellipsis and read more button
              <>
                ...{' '}
                <button
                  className={styles.readMoreButton}
                  onClick={() => setIsExpanded(true)}
                >
                  Read more
                </button>
              </>
            ) : null}
          </p>
        ))}
        {isExpanded && (
          <>
            <div
              className={styles.expandedContainer}
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <button
              className={styles.readMoreButton}
              onClick={() => setIsExpanded(false)}
            >
              Read less
            </button>
          </>
        )}
      </div>
    </>
  );
};
